<section class="login-wrapper">
  <div class="container">
    <div class="row justify-content-center align-items-center min-vh-100">
      <div class="col-12 col-sm-10 col-md-8 col-lg-5">

        <!-- ANA KART -->
        <div class="login-card shadow-lg">

          <!-- LOGO VE BAŞLIK BÖLÜMÜ -->
          <div class="login-header text-center mb-4">
            <img src="https://ankara.edu.tr/assets/images/logo.png" class="university-logo mb-3" alt="Ankara Üniversitesi" />
            <h1 class="title">Ankara Üniversitesi</h1>
            <p class="subtitle">Online Yoklama Platformu</p>
          </div>

          <!-- FORM BAŞLANGIÇ -->
          <form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()" class="px-3">

            <!-- YÖNETİCİ TOGGLE -->
           <!--  <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="fw-bold text-secondary">Giriş Türü</span>
              <mat-slide-toggle formControlName="isAdmin" (change)="onRoleToggle($event)" color="primary">
                Yönetici Girişi
              </mat-slide-toggle>
            </div> -->

            <hr class="my-4">

            <!-- DİNAMİK FORM ALANLARI -->
            <div class="form-fields">
              <!-- YÖNETİCİ FORMU -->
              <div *ngIf="form.value.isAdmin" class="animate-fade">
                <div class="mb-3">
                  <label class="form-label small fw-bold text-uppercase">Email Adresi</label>
                  <input formControlName="email" type="email" class="form-control form-control-lg" placeholder="Örn: ad.soyad@ankara.edu.tr" />
                </div>

                <div class="mb-3">
                  <label class="form-label small fw-bold text-uppercase">Parola</label>
                  <input formControlName="password" type="password" class="form-control form-control-lg" placeholder="••••••••" />
                </div>
              </div>

              <!-- ÖĞRENCİ / HOCA FORMU -->
              <div *ngIf="!form.value.isAdmin" class="animate-fade">
                <div class="mb-3">
                  <label class="form-label small fw-bold text-uppercase">Öğrenci No / Sicil No</label>
                  <input formControlName="email" #emailInput type="text" class="form-control form-control-lg"
                         (input)="onOkulNoChange($event)" placeholder="Numaranızı giriniz" />
                </div>

                <div class="mb-3">
                  <label class="form-label small fw-bold text-uppercase">Parola</label>
                  <input formControlName="password" type="password" class="form-control form-control-lg" placeholder="••••••••" />
                </div>
              </div>
            </div>

            <!-- BENİ HATIRLA -->
            <div class="mb-3">
              <mat-checkbox formControlName="rememberMe" color="primary">
                Beni Hatırla
              </mat-checkbox>
            </div>

            <!-- GİRİŞ BUTONU -->
            <button type="submit" class="btn btn-primary btn-lg w-100 shadow-sm fw-bold">
              Giriş Yap
            </button>

            <!-- KILAVUZ BAĞLANTISI (İstediğin Link) -->
            <div class="text-center mt-4">
              <a href="https://akilliyoklama.ankara.edu.tr/yoklamaklavuz/" target="_blank" class="guide-link">
                <i class="bi bi-info-circle me-1"></i> Sistem Kullanım Kılavuzu
              </a>
            </div>

          </form>
        </div>

        <!-- ALT BİLGİ -->
        <div class="text-center mt-3 text-white-50">
          <small>&copy; 2026 Ankara Üniversitesi Bilgi İşlem</small>
        </div>

      </div>
    </div>
  </div>
</section>
